import React, { Component } from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import './index.scss'
import ArrowLeft from 'assets/images/arrow-left-bronze.svg'
import ArrowRight from 'assets/images/arrow-right-bronze.svg'

class NavArrows extends Component {
  render () {
    return (
      <div className='nav-arrows'>
        <Link to={this.props.prevURL} className='nav-arrows__prev'><img src={ArrowLeft} alt='Previous' /></Link>
        <Link to={this.props.nextURL} className='nav-arrows__next'><img src={ArrowRight} alt='Next' /></Link>
      </div>
    )
  }
}

NavArrows.propTypes = {
  prevURL: PropTypes.string,
  nextURL: PropTypes.string,
}

export default NavArrows



// WEBPACK FOOTER //
// ./src/components/NavArrows/index.js